import { Lock, LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslation } from '@/hooks/useTranslation'

interface BlurredFieldProps {
	label: string
	icon: LucideIcon
	className?: string
}

export function BlurredField({ label, icon: Icon, className }: BlurredFieldProps) {
	const { t } = useTranslation()
	return (
		<div
			className={cn("flex justify-between items-center opacity-75", className)}
			aria-label={t('blurredField.proFeatureUpgradeToUnlock', { label })}
		>
			<span className="text-xs font-medium text-muted-foreground flex items-center gap-1 shrink-0">
				<div className="h-3 w-3 flex items-center justify-center">
					<Icon className="h-2 w-2 text-primary" />
				</div>
				{label}:
			</span>
			<div className="relative flex items-center justify-end min-w-0 flex-1 ml-2">
				<span className="text-xs font-medium blur-[3px] select-none text-muted-foreground pointer-events-none" aria-hidden="true">
					{t('blurredField.hiddenData')}
				</span>
				<Lock className="h-3 w-3 text-amber-600 dark:text-amber-400 shrink-0 absolute right-0" aria-label={t('blurredField.lockedUpgradeToProToView')} />
			</div>
		</div>
	)
}
